@if (showIcon) {
    <span class="role-icon">
        <i class="fal fa-fw fa-inverse fa-user-tag"
           aria-hidden="true"></i>
    </span>
}

<!-- Text alignment is best if there aren't any new lines in this inline element
(same for ng-template below) -->
@if (role$ | async; as role) {
    <a [class.btn-link]="openConfigOnClick && canConfigureRole"
       (click)="openConfigOnClick && canConfigureRole ? configureRole(role).subscribe() : undefined"
       [routerLink]="!openConfigOnClick || !canConfigureRole ? (roleDescriptionUrl$ | async) : undefined">
        <span adaptTooltip="This is a new / unsaved role"
              [tooltipEnabled]="role!.roleId < 1">{{ role!.label }}</span></a>
} @else {
    (No role allocated)
}
